module.exports = __webpack_public_path__ + "img/home-02-bg-intro.dae3616f.jpg";